import { z } from 'zod';
import { emailSchema, passwordSchema, usernameSchema } from './auth.js';
import { isoDateSchema } from './common.js';

export const updateAccountSchema = z.object({ username: usernameSchema });

export const updateEmailSchema = z.object({
  email: emailSchema,
  currentPassword: z.string().min(1).max(256),
});

export const updatePasswordSchema = z.object({
  currentPassword: z.string().min(1).max(256),
  newPassword: passwordSchema,
});

export const twoFactorSetupSchema = z.object({
  secret: z.string(),
  otpauthUri: z.string(),
  /** SVG markup of the QR code for otpauthUri. */
  qrSvg: z.string(),
});

export const enableTwoFactorSchema = z.object({
  code: z
    .string()
    .trim()
    .regex(/^\d{6}$/, 'Enter the 6-digit code from your app.'),
  currentPassword: z.string().min(1).max(256),
});

export const recoveryCodesSchema = z.object({ recoveryCodes: z.array(z.string()) });

export const passwordConfirmSchema = z.object({ currentPassword: z.string().min(1).max(256) });

export const accountSessionSchema = z.object({
  id: z.number().int(),
  ip: z.string().nullable(),
  userAgent: z.string().nullable(),
  current: z.boolean(),
  impersonated: z.boolean(),
  createdAt: isoDateSchema,
  lastSeenAt: isoDateSchema,
});
export type AccountSession = z.infer<typeof accountSessionSchema>;
